"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectDataSection = void 0;
const types_1 = require("../../../types");
exports.projectDataSection = {
    label: "form.project.label",
    name: "projectdata",
    subline: "form.project.subline",
    fields: [
        {
            name: "product_name",
            label: "form.project.productName",
            type: types_1.FormFieldType.long,
        },
        {
            name: "type",
            label: "form.project.productType",
            type: types_1.FormFieldType.long,
        },
        {
            name: "cost_center",
            label: "form.project.costCenter",
            type: types_1.FormFieldType.input,
        },
        {
            name: "serial_number",
            label: "form.project.serialNumber",
            type: types_1.FormFieldType.input,
        },
        {
            name: "launch_date",
            label: "form.project.launchDate",
            type: types_1.FormFieldType.input,
            info: "for testing use: 2014-01-08T08:54:44+01:00",
        },
        {
            name: "description",
            label: "form.project.description",
            info: "Beschreiben Sie die Konstruktion.",
            type: types_1.FormFieldType.area,
        },
    ],
};
exports.default = exports.projectDataSection;
